export default __webpack_public_path__ + "static/media/apple-cicle.07184010.jpg";